module.exports = __webpack_public_path__ + "static/media/epgdefaultchannelimageleft.430ef17c.png";